import {
  inputCss,
  modalOverlay,
  modalStyle,
  primaryBtn,
  secondaryBtn,
} from './role-detail.support';

export function RoleEditModal(props: {
  name: string;
  description: string;
  editName: string;
  setEditName: (v: string) => void;
  editDesc: string;
  setEditDesc: (v: string) => void;
  onCancel: () => void;
  onSave: () => void;
}) {
  const { name, description, editName, setEditName, editDesc, setEditDesc, onCancel, onSave } =
    props;
  return (
    <div style={modalOverlay}>
      <div style={modalStyle}>
        <h3 style={{ margin: '0 0 1rem' }}>Editar papel</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <input
            value={editName || name}
            onChange={(e) => {
              setEditName(e.target.value);
            }}
            placeholder="Nome"
            style={inputCss}
          />
          <input
            value={editDesc || description}
            onChange={(e) => {
              setEditDesc(e.target.value);
            }}
            placeholder="Descrição"
            style={inputCss}
          />
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
            <button onClick={onCancel} style={secondaryBtn}>
              Cancelar
            </button>
            <button onClick={onSave} style={primaryBtn}>
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
